import { Typography } from '@mui/material';
import { range } from 'lodash-es';
import bind from 'memoize-bind';
import moment from 'moment-timezone';
import React, { Fragment, PureComponent } from 'react';

import PrevMonthIcon from '@sbu/assets.svg/src/single-chevron-left.svg';
import NextMonthIcon from '@sbu/assets.svg/src/single-chevron-right.svg';
import { Button, IconButton } from '@sumologic/yama-ds-components';

import { CalendarNavigation } from './CalendarNavigation';
import css from './CalendarYear.module.scss';

interface CalendarYearProps {
  viewValue: Date;
  onViewChange: (view: 'day' | 'month' | 'year') => void;
  onViewValueChange: (Date) => void;
  onDirectionChange: (direction: 0 | 1 | -1) => void;
}

interface CalendarYearState {
  activeIndex: number;
}

export class CalendarYear extends PureComponent<
  CalendarYearProps,
  CalendarYearState
> {
  state = { activeIndex: 0 };

  setFocus(activeIndex: number) {
    this.setState({ activeIndex });
  }

  onYearClick(year: number) {
    const { viewValue, onViewChange, onViewValueChange } = this.props;
    const m = moment(viewValue).get('month');

    onViewValueChange(moment([year, m]).toDate());
    onViewChange('month');
  }

  onArrowClick(direction: -1 | 1) {
    const { viewValue, onViewValueChange, onDirectionChange } = this.props;
    const range = direction * this.getYears().length;

    onViewValueChange(moment(viewValue).add(range, 'year').toDate());

    onDirectionChange(direction);
  }

  getYears() {
    const currentYear = moment(this.props.viewValue).get('year');

    return range(currentYear - 8, currentYear + 8);
  }

  renderYear(year: number) {
    return (
      <Button
        className={css.year}
        data-sumo-test={`calendar-month-view-${year}`}
        key={year}
        onClick={() => this.onYearClick(year)}
        size='small'
        variant='text'
      >
        {year}
      </Button>
    );
  }

  render() {
    const { activeIndex } = this.state;
    const years = this.getYears();

    return (
      <Fragment>
        <div className={css.header}>
          <IconButton
            size='medium'
            color='secondary'
            data-sumo-test='calendar-year-view-previous-button'
            onClick={() => this.onArrowClick(-1)}
            sx={{ m: 0, p: 0, pt: 0.625, px: 0.625 }}
          >
            <PrevMonthIcon />
          </IconButton>
          <div className={css.monthYear}>
            <Typography variant='subtitle1' mb={0}>
              {years[0]} - {years[years.length - 1]}
            </Typography>
          </div>
          <IconButton
            size='medium'
            color='secondary'
            data-sumo-test='calendar-year-view-next-button'
            onClick={() => this.onArrowClick(1)}
            sx={{ m: 0, p: 0, pt: 0.625, px: 0.625 }}
          >
            <NextMonthIcon />
          </IconButton>
        </div>
        <CalendarNavigation
          activeIndex={activeIndex}
          className={css.allYears}
          numColumns={4}
          onIndexChange={bind(this.setFocus, this)}
        >
          {years.map((year) => this.renderYear(year))}
        </CalendarNavigation>
      </Fragment>
    );
  }
}
